module.exports = __webpack_public_path__ + "static/media/relax-bg1.81b5e45b.svg";